import React from 'react';
import { motion } from 'framer-motion';
import './Testimonials.css';


const testimonialsData = [
  {
    quote: "The blood bank website developers were innovative and reliable. They transformed us into a seamless platform, boosting donor registrations by 40% and improving efficiency.",
    name: "Ashok Bhai Patel",
    company: "Shree Blood Bank",
    image: "https://placehold.co/100x100/121212/FFFFFF?text=JS"
  },
  {
    quote: "The hospital web and emergency contact system they developed is phenomenal. It's intuitive, secure, and has greatly improved our patient care workflow.",
    name: "Dr. Vaibhav Patel",
    company: "Ved Hospital",
    image: "https://placehold.co/100x100/181818/FFFFFF?text=VP"
  },
  {
    quote: "Our new website is not just beautiful, it's a powerful tool that has boosted our online presence and customer engagement significantly.",
    name: "LAXMIBEN R. PATEL",
    company: "Windson Packaging",
    image: "https://placehold.co/100x100/1E1E1E/FFFFFF?text=LP"
  },
  {
    quote: "DEPLOY-X transformed our operations. Their AI-powered platform has increased our efficiency by over 40%. A truly innovative and reliable partner.",
    name: "John S.",
    company: "CEO, TechCorp Solutions",
    image: "https://placehold.co/100x100/121212/FFFFFF?text=JS"
  },
  {
    quote: "Working with DEPLOY-X was a seamless experience. Their expertise in  web developement is unmatched, and they delivered beyond our expectations.",
    name: "Mahesh Bhai Patel",
    company: "Jalaram Sawmill",
    image: "https://placehold.co/100x100/2a2a2a/FFFFFF?text=MP"
  },
  {
    quote: "The business ERP solution has become the backbone of our inventory management. It's robust, scalable, and incredibly user-friendly.",
    name: "Dhawal Rawal",
    company: "Global Logistics",
    image: "https://placehold.co/100x100/333333/FFFFFF?text=DR"
  }
];

// We duplicate the testimonials to create a seamless infinite scroll effect
const duplicatedTestimonials = [...testimonialsData, ...testimonialsData];

const Testimonials = () => {
  return (
    <section id="testimonials">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">What Our <span>Clients Say</span></h2>
          <p className="section-subtitle">
            We are proud to have partnered with innovative companies to deliver exceptional results.
          </p>
        </motion.div>

        <div className="laptop-container">
          <div className="laptop-frame">
            <div className="laptop-screen">
              <div className="scrolling-track">
                {duplicatedTestimonials.map((testimonial, index) => (
                  <div className="testimonial-card" key={index}>
                    <p className="testimonial-quote">"{testimonial.quote}"</p>
                    <div className="testimonial-author">
                      <img src={testimonial.image} alt={testimonial.name} className="author-image" />
                      <div className="author-info">
                        <span className="author-name">{testimonial.name}</span>
                        <span className="author-company">{testimonial.company}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="laptop-bottom">
              <div className="laptop-stand"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;